import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';

type Response = {
  success: boolean;
  message: string;
};

export const saveEmailTemplate = withLogger(
  async (payload): Promise<Response> => {
    const url = globalLetterAPIUrls.emailTemplate.save;

    const { data } = await authServiceAxiosClient.post<Response>(url, payload);

    return data;
  },
);
